/* eslint-disable camelcase */
import api from './api';
import { NotificationGroupSubscriptionSnapshot } from '../models/Notification/NotificationGroupSubscription';
import { ChannelType } from '../constants/notification';
import { getBackVersion } from '../config';

const getNotificationGroupSubscriptions = (): Promise<
    NotificationGroupSubscriptionSnapshot[]
> => {
    return api.request<NotificationGroupSubscriptionSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/notifications`,
    });
};

const enableNotificationGroupSubscription = (
    slug: string,
    channel: ChannelType
): Promise<NotificationGroupSubscriptionSnapshot> => {
    return api.request<NotificationGroupSubscriptionSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/notifications`,
        data: {
            notification_group_slug: slug,
            channel: channel,
        },
    });
};

const disableNotificationGroupSubscription = (
    slug: string,
    channel: ChannelType
): Promise<NotificationGroupSubscriptionSnapshot> => {
    return api.request<NotificationGroupSubscriptionSnapshot>({
        method: 'DELETE',
        url: `${getBackVersion()}/notifications`,
        data: {
            notification_group_slug: slug,
            channel: channel,
        },
    });
};

const guestUnsubscribe = (token: string): Promise<void> =>
    api.request<void>({
        method: 'POST',
        url: `${getBackVersion()}/notifications/guest_unsubscribe/${token}`,
    });

const NotificationGroupSubscriptionResource = {
    getNotificationGroupSubscriptions,
    enableNotificationGroupSubscription,
    disableNotificationGroupSubscription,
    guestUnsubscribe,
};

export default NotificationGroupSubscriptionResource;
